import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Pane extends Component {
  static propTypes = {
    header: PropTypes.any,
    body: PropTypes.any,
  };

  render() {
    const { t } = this.props;
    return (
      <Panel header={t('SHIPMENT_DETAILS')} defaultExpanded>
        {this.props.header}
        {this.props.body}
      </Panel>
    );
  }
}

export default withTranslation()(Pane);
